export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=101f4761&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/index.vue?vue&type=template&id=101f4761&scoped=true
// module id = p2Em
// module chunks = 0